export default "__VITE_ASSET__ByF937p4__"